import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const DiscountByTimeReport = ({
  chartData,
  chartOptions,
  storess,
  range,
  chartRef,
  containerId,
}) => (
  <div ref={chartRef} id={containerId}>
    <div className="card p-4">
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>

    <div className="print-only-content">
      <h2>Report Details</h2>
      <div className="print-only-content">
        <div>
          <h3>Brand: Angels Pizza</h3>
          <h3>Store: {storess}</h3>
          <h3>
            Date:{" "}
            {range?.tran_date?.$gte && range?.tran_date?.$lte
              ? `${new Date(range.tran_date.$gte).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })} - ${new Date(range.tran_date.$lte).toLocaleDateString(
                  "en-US",
                  {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  },
                )}`
              : "No date selected"}
          </h3>
        </div>
      </div>

      <div style={{ fontSize: "20px" }}>
        <table className="table text-center">
          <thead>
            <tr className="d-flex">
              <th>Time</th>
              <th className="ms-5">Discount Value</th>
            </tr>
          </thead>
          <tbody>
            {chartData.labels.map((label, index) => (
              <tr className="d-flex" key={`${containerId}-${index}`}>
                <td className="ms-5">{label}</td>
                <td className="ms-5">{chartData.discountData[index]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default DiscountByTimeReport;
